
import React from "react";
import ClassPage2 from "./classPage2";
import Header from "../headerFooter/header";
import HomeFooter from "../homepage/homefooter";

const ClassFull = () => {
    return(
        <> 
            <Header />
            {/* Wrapper to ensure padding from header if needed */}
            <div style={{ paddingTop: '0' }}> 
                <ClassPage2/>
            </div>
            <HomeFooter/>
        </>
    )
}; 

export default ClassFull;